export const MessageStatusType = {
  Pending: 0,
  Sent: 1,
  Delivered: 2,
  Read: 3,
  Error: 99,
} as const;

export type MessageStatusType =
  (typeof MessageStatusType)[keyof typeof MessageStatusType];
